module.exports = {"Marriage1":{"daobanList":[{"title":"1:是否投靠配偶","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、具名户口簿","state":"必要"},{"name":"2、居民身份证","state":"必要"},{"name":"3、结婚证（或亲属关系材料）","state":"必要"},{"name":"4、不动产权证书（或入户地址材料）","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sdm-1.json
// module id = 1266
// module chunks = 0